/** @format */
import { localizedStringFilterModule } from 'sis-common';
(function () {
  completionMethodRepeatTexts.$inject = ["$filter"];
  angular.module('student.common.components.courseUnitInfoModal.repeatTexts', [localizedStringFilterModule]).filter('completionMethodRepeatTexts', completionMethodRepeatTexts);

  /**
   * Join completion method repeat texts to a readable string.
   */
  function completionMethodRepeatTexts($filter) {
    return function (repeatTexts) {
      return _.map(repeatTexts, function (repeatText) {
        return _.map(repeatText, function (obj) {
          return $filter('localizedString')(obj.name);
        }).join(' - ');
      }).join(', ');
    };
  }
})();